import { Helmet } from "react-helmet-async";
import { useEffect, useContext, useState } from "react";
import { AppContext } from "../../context/AppContext";


const MetaTag = ({title,keywords,descreption}) => {
    const { metaTag } = useContext(AppContext);
    return (
      <>
        <Helmet>
         
         <meta
            name='title'
            content={title}
          />
          <meta
            name='keywords'
            content={keywords}
          />
           <meta
            name='descreption'
            content={descreption}
          />
          
        </Helmet>
      </>
    );
}
export default MetaTag;